import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "SensitivityGAPGlobal" })((_theme) => ({
  page: {
    margin: "20px",
  },
  sensitivityGAPGlobalExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
